<template>
  <div class="content">
    <div class="header">
      <el-select placeholder="账龄类型" size="mini" clearable v-model="where2.age">
        <el-option :value="1" label="当期"></el-option>
        <el-option :value="2" label="纯上一年"></el-option>
        <el-option :value="3" label="1年以上2年以内"></el-option>
        <el-option :value="4" label="2年以上"></el-option>
      </el-select>
      <el-date-picker
        style="width: 150px"
        v-model="where2.jh_time"
        size="mini"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM" placeholder="催费月份">
      </el-date-picker>
      <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>

      <el-popover
        placement="bottom"
        width="300"
        trigger="hover">
        <el-button @click="startFlow(1,2)">发起流程（在管）</el-button>
        <el-button @click="startFlow(2,2)">发起流程（撤场）</el-button>
        <el-button slot="reference">部分发起流程</el-button>
      </el-popover>

      <el-popover
        placement="bottom"
        width="300"
        trigger="hover">
        <el-button @click="startFlow(1,1)">发起流程（在管）</el-button>
        <el-button @click="startFlow(2,1)">发起流程（撤场）</el-button>
        <el-button slot="reference">全部发起流程</el-button>
      </el-popover>

      <el-button type="danger" size="mini" @click="deleteLegalHouse()">删除计划</el-button>


    </div>
    <div class="header-tip">
      申请房产数：{{pageData.total}}
    </div>
    <div class="body">
      <div>
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            v-if="pageData" :data="pageData.list"
            border
            style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column
              prop="房产信息"
              label="房产信息" width="320" fixed></el-table-column>
            <el-table-column
              prop="区域"
              label="区域"
              width="90">
            </el-table-column>
            <el-table-column
              prop="业主"
              label="业主"
              width="100">
            </el-table-column>
            <el-table-column
              prop="业主电话"
              label="业主电话"
              width="150">
            </el-table-column>
            <el-table-column
              label="银行划扣"
              width="90">
              <template slot-scope="scope">
                <span style="color: #328628" v-if="scope.row.bankType">是</span>
                <span v-if="!scope.row.bankType"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="欠费起始月份"
              label="欠费起始月份"
              width="120">
            </el-table-column>
            <el-table-column
              prop="欠费月数"
              label="欠费月数"
              width="100">
            </el-table-column>
            <el-table-column
              prop="欠费金额"
              label="欠费金额"
              width="100">
              <template slot-scope="scope">
                <el-link type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row['欠费金额'] }}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="催缴类型"
              label="催缴类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="第三方合作单位"
              label="第三方合作单位"
              width="150">
            </el-table-column>
            <el-table-column
              prop="账龄类型"
              label="账龄类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="缴费类型"
              label="缴费类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="计划催缴月份"
              label="计划催缴月份"
              width="100">
            </el-table-column>
            <el-table-column
              prop="上次缴费时间"
              label="上次缴费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第一次催费时间"
              label="第一次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第二次催费时间"
              label="第二次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="第三次催费时间"
              label="第三次催费时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="催费次数"
              label="催费次数"
              width="90">
            </el-table-column>
            <el-table-column
              prop="欠费类型"
              label="欠费类型"
              width="150">
            </el-table-column>
            <el-table-column
              prop="欠费原因"
              label="欠费原因"
              width="150">
            </el-table-column>
            <el-table-column
              prop="业主诉求"
              label="业主诉求"
              width="150">
            </el-table-column>
            <el-table-column
              label="操作"
              width="150" fixed="right">
              <template slot-scope="scope">
<!--                <el-button type="primary" size="mini" @click="editType(scope.row)">变更催缴</el-button>-->
                <el-button type="danger" size="mini" @click="deleteLegalHouse(scope.row)">删除计划</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
      <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

        <div class="view-file-win">
          <el-descriptions class="margin-top" :column="1" size="mini" border>
            <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
            <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
            <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
            <el-descriptions-item label="催缴类型">
              <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
                <el-option value="自催" label="自催"></el-option>
                <el-option value="诉讼" label="诉讼"></el-option>
                <el-option value="第三方管理" label="第三方管理"></el-option>
                <el-option value="第三方诉讼" label="第三方诉讼"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="计划催缴月份">
              <el-date-picker
                style="width: 150px"
                v-model="from_data['计划催缴月份']"
                size="mini"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM">
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
            <el-descriptions-item label="欠费类型">
<!--              <el-select placeholder="催缴类型" v-model="from_data['催缴类型']" @change="changeType">-->
<!--                <el-option v-for="(item,index) in type_list" :key="index" :value="item.name" :label="item.name"></el-option>-->
<!--              </el-select>-->
              {{ from_data['欠费类型'] }}
            </el-descriptions-item>
            <el-descriptions-item label="欠费原因">
<!--              <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">-->
<!--                <el-option v-for="(item,index) in type_list_sub" :key="index" :value="item.name" :label="item.name"></el-option>-->
<!--              </el-select>-->
              {{ from_data['欠费原因'] }}
            </el-descriptions-item>
            <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <template slot="footer">
          <div>
            <el-button @click="onClose">关 闭</el-button>
            <el-button @click="editTypeSubmit">修 改</el-button>
          </div>
        </template>
      </el-dialog>

      <el-dialog title="欠费明细" :visible.sync="dialogVisible_1" :close-on-click-modal="false" width="80vw">

        <div class="view-file-win">
          <el-table
            v-loading="loading" :data="house_bill_order" height="60vh"
            border
            style="width: 100%">
            <el-table-column
              prop="h_name_date"
              label="房产信息" width="360" fixed></el-table-column>
            <el-table-column
              prop="charge_name"
              label="费项"
              width="150">
            </el-table-column>
            <el-table-column
              prop="BillDate"
              label="收费周期"
              width="150">
            </el-table-column>
            <el-table-column
              prop="charge"
              label="金额"
              width="100">
            </el-table-column>
            <el-table-column
              prop="h_name"
              label="业主">
            </el-table-column>
          </el-table>
        </div>
        <template slot="footer">
          <div>
            <el-button @click="dialogVisible_1=false">关 闭</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Http from "../../common/Http";
import moment from "moment/moment";
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "ThirdPartyLegalPlan",
  inject:['where','reginWhere'],
  props: {
    urge_type:{
      type:Number,
      default:0
    }
  },
  data(){
    return{
      where2:{
        age:"",
        type:"",
        jh_time:"",
        house_name:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      from_data:{},
      dialogVisible:false,
      house_bill_order:[],
      dialogVisible_1:false,
      multipleSelection:[],
      type_list:[
        {
          "id": 4,
          "name": "房屋及基础措施类",
          "children": [
            {
              "id": 5,
              "name": "房屋质量问题"
            },
            {
              "id": 6,
              "name": "物业管理的公共部分导致的房屋质量问题"
            },
            {
              "id": 7,
              "name": "公共设施原因"
            }
          ]
        },
        {
          "id": 5,
          "name": "物业服务类",
          "children": [
            {
              "id": 8,
              "name": "安保管理安全问题"
            },
            {
              "id": 9,
              "name": "物业人员服务态度问题"
            },
            {
              "id": 10,
              "name": "物业管理服务不到位问题"
            },
            {
              "id": 11,
              "name": "工程维修问题"
            }
          ]
        },
        {
          "id": 6,
          "name": "业主自身原因类",
          "children": [
            {
              "id": 12,
              "name": "炒房"
            },
            {
              "id": 13,
              "name": "失联"
            },
            {
              "id": 14,
              "name": "异地居住"
            },
            {
              "id": 15,
              "name": "拖延缴费"
            }
          ]
        },
        {
          id: 16,
          name: "正常缴费",
        },
        {
          "id": 7,
          "name": "其它(手写)"
        }
      ],
      type_list_sub:[]
    }
  },
  mounted() {
    const that=this;
    that.getList();
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.start_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where.thrid_company_id":function (n,o){
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    }
  },
  methods:{
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        thrid_company_id:that.where.thrid_company_id,
        urge_type:that.urge_type,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      ButlerHttp.post("ThirdPartyLegal/getLegalHouseList", {
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    exportExcel(type=1) {
      const that = this;
      console.log(that.reginWhere.project_name)
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post(type===1?"Legal/getLegalHouseExcel2":"Legal/getLegalHouseExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    importLegalHouseExcel(){
      const that=this;
      Http.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("Legal/importLegalHouseExcel", {
          file: file
        }, res => {
          loading.close();
          if (res.code) {
            that.pageChange(1);
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    editType(item){
      const that=this;
      that.from_data=item;
      that.dialogVisible=true;
    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={}
    },
    editTypeSubmit(){
      const that=this;
      let urge_type_obj={
        '自催':1,
        '诉讼':2,
        '第三方':3
      }
      ButlerHttp.post("ThirdPartyLegal/updateLegalHouseType", {
        id: that.from_data.id,
        ch_md5: that.from_data.ch_md5,
        urge_type: urge_type_obj[that.from_data['催缴类型']],
        year_month: that.from_data['计划催缴月份']
      }, res => {
        if (res.code) {
          that.onClose();
          that.$message.success("操作成功");
          that.pageChange(1);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    startFlow(type=1,d_type=1){
      const that = this;
      let where = {}
      if(d_type===1){
        where={
          ...that.where2,
          thrid_company_id:that.where.thrid_company_id,
          urge_type:that.urge_type,
          project_ids:that.reginWhere.project_ids,
          project_id:that.reginWhere.project_name,
          // area_id:that.areaId
        }
      }else {
        if(that.select_ids.length===0){
          that.$message.error('请选择记录')
          return false
        }
        where.ids=that.select_ids.join(',')
      }
      that.loading = true;
      ButlerHttp.post("ThirdPartyLegal/getBatchNumber", {
        ...where
      }, res => {
        if (res.code) {
          let timeValue = new Date().getTime();
          if (type === 1) {
            //在管
            if(that.urge_type==4){
              //第三方诉讼
              ERP.navigateTo("/flow/FlowView?sheet_id=209&master_id=173&batch_number=" + res.data + '&timeValue=' + timeValue);
            }else{
              //第三方管理
              ERP.navigateTo("/flow/FlowView?sheet_id=68&master_id=65&batch_number=" + res.data + '&timeValue=' + timeValue);
            }
          } else {
            //撤场
            ERP.navigateTo("/flow/FlowView?sheet_id=69&master_id=66&batch_number=" + res.data + '&timeValue=' + timeValue);
          }
        } else {
          that.$message.error(res.msg || "无数据");
        }
        that.loading = false;
      });
    },
    getHouseBill(item){
      const that=this;
      ERP.showLoading()
      ButlerHttp.post("Legal/getHouseBill", {
        projectId: item.PrecinctID,
        houseId: item.HouseID
      }, res => {
        ERP.hideLoading();
        if (res.code) {
          that.dialogVisible_1 = true;
          that.house_bill_order = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    selectRemove(){
      const that=this;
      if(that.select_ids.length===0){
        that.$message.error('请选择记录')
        return false
      }

      ButlerHttp.post("Litigation/deleteItem", {
        ids: that.select_ids.join(',')
      }, res => {
        if (res.code) {
          that.pageChange(1);
          that.getAjaxCount();
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    selectStartFlow(){
      const that = this;

      if(that.select_ids.length===0){
        that.$message.error('请选择记录')
        return false
      }

      ButlerHttp.post("Litigation/getBatchNumber", {
        ids: that.select_ids.join(',')
      }, res => {
        if (res.code) {
          let timeValue = new Date().getTime();
          ERP.navigateTo("/flow/FlowView?sheet_id=66&master_id=63&batch_number=" + res.data + '&timeValue=' + timeValue);
        } else {
          that.$message.error(res.msg || '批次号获取异常');
        }
      });
    },
    deleteLegalHouse(item=null){
      const that = this;
      if(item){
        that.multipleSelection=[item]
      }
      that.loading = true;
      let where = {
        ...that.where2,
        thrid_company_id:that.where.thrid_company_id,
        urge_type:that.urge_type,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        ids:that.select_ids.join(',')
      }

      ButlerHttp.post("ThirdPartyLegal/deleteLegalHouse", {
        ...where,
      }, res => {
        if (res.code) {
          that.pageChange(1);
        }
        that.loading = false;
      });
    }
  },
  computed:{
    select_ids(){
      return this.multipleSelection.map(ret=>ret.id)
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ThirdPartyLegalPlan.vue